import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import 'rxjs/add/operator/filter';
import { RSP_ROLES, CONTRACT_ROLES, DOCSTORE_ROLES } from 'src/app/shared/enums/admin-enum';
import { PATH_ROUTING } from 'src/app/shared/enums/routing-enums';
import { Spinner } from '../../../../../../core/services/spinner.service';
import { SrmService } from '../../../../../../shared/service/srm.service';

@Component({
  selector: 'app-admin-srm',
  templateUrl: './admin-srm.component.html',
  styleUrls: ['./admin-srm.component.scss']
})
export class AdminSRMComponent implements OnInit {

  public menuType = '';
  public params = 'welcome-message';
  public isOpen = false;
  public menuAdmin: string;

  public menu = [
    {
      id: '',
      url: PATH_ROUTING.PATH_DASHBOARD,
      title: 'Dashboard',
      permissions: [],
      hidden: true
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_WELCOME_MESSAGE,
      title: 'Welcome Message',
      permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO],
      hidden: true
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_SECTION,
      title: 'Quick Links',
      permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO],
      hidden: true
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_NEWS,
      title: 'News',
      permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO],
      hidden: true
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_ROLES,
      title: 'Roles Management',
      permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER],
      hidden: true
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_GE_ADMIN_STATUES,
      title: 'GE Tag ID Request Statuses',
      permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.GE_TAG_ID_ADMIN],
      hidden: true
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_SUPPIER_USER,
      title: 'SRM External Supplier Access',
      permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.EOL_ADMIN],
      hidden: true
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_INTERNAL_USER,
      title: 'Internal SRM Access',
      permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS],
      hidden: true
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_CONTRACT_ACCESS,
      title: 'Contract Access Management',
      permissions: [RSP_ROLES.ADMIN,CONTRACT_ROLES.CONTRACT_ADMIN],
      hidden: true
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_DOCSTORE_ACCESS,
      title: 'Docstore Access Management',
      permissions: [RSP_ROLES.ADMIN, DOCSTORE_ROLES.DOCSTORE_ADMIN],
      hidden: true
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_APPICATION_ACCESS_STATUS,
      title: 'Application Access Statuses',
      permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS],
      hidden: true
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_APPLICATION_ACCESS_ASSIGNMENT,
      title: 'Application Access Assignment Group',
      permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.GE_TAG_ID_ADMIN, RSP_ROLES.EOL_ADMIN],
      hidden: true
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_APPLICATION_REVOKE_ASSIGNMENT,
      title: 'Application Revoke Assignment Group',
      permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS],
      hidden: true
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_TRAINING_DOCUMENT_ADMIN,
      title: 'My Training Document Admin',
      permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER],
      hidden: true
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_GE_CONFIDENTIAL_DOCUMENTS_ADMIN,
      title: 'Documents',
      permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER],
      hidden: true
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_STAY_INFORMED_ADMIN,
      title: 'Stay Informed Admin',
      permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER],
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_SCORECARD_SETTING,
      title: 'Scorecard KPIs Setting',
      permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS],
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_RATING_GUIDELINE,
      title: 'Upload Rating Guideline',
      permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.OPERATOR_INFO, RSP_ROLES.SUPPLIER],
    },
    {
      id: '',
      url: PATH_ROUTING.PATH_EOL_SETUPS,
      title: 'EOL Setups',
      permissions: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.EOL_ADMIN],
    },
  ];

  constructor(
    private srmService: SrmService,
    private spinner: Spinner,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.checkShowMenuAdmin();
    this.router.events.filter(event => event instanceof NavigationEnd)
    .subscribe((res: any) => {
      if (res.url === '/srm/admin') {
        this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, this.menu[0].url]);
      }
      const url = res.urlAfterRedirects.split('/');
      if (url[3] === 'application-link' || url[3] === 'edit-section' || url[3] === PATH_ROUTING.PATH_ADD_SECTION
      || url[3] === 'add-application-link' || url[3] === 'edit-application-link') {
        this.menuAdmin = PATH_ROUTING.PATH_SECTION;
      } else if (url[3] === PATH_ROUTING.PATH_ADD_SUPPIER_USER || url[3] === 'edit-supplier') {
        this.menuAdmin = PATH_ROUTING.PATH_SUPPIER_USER;
      } else if (url[3] === PATH_ROUTING.PATH_ADD_INTERNAL_USER || url[3] === 'edit-internal-user') {
        this.menuAdmin = PATH_ROUTING.PATH_INTERNAL_USER;
      } else if (url[3] === PATH_ROUTING.PATH_ADD_NEWS || url[3] === 'edit-news') {
        this.menuAdmin = PATH_ROUTING.PATH_NEWS;
      } else if (url[3] === 'revoke-access') {
        this.menuAdmin = PATH_ROUTING.PATH_APPICATION_ACCESS_STATUS;
      } else if (url[3] === PATH_ROUTING.PATH_ADD_ROLE || url[3] === 'edit-role') {
        this.menuAdmin = PATH_ROUTING.PATH_ROLES;
      } else if (url[3] === PATH_ROUTING.PATH_GE_ADMIN_STATUS_UPDATE || url[3] === 'update-status') {
        this.menuAdmin = PATH_ROUTING.PATH_GE_ADMIN_STATUES;
      }else if (url[3] === PATH_ROUTING.PATH_TRAINING_DOCUMENT_ADMIN_ADD || url[3] === 'edit-application-training-document') {
        this.menuAdmin = PATH_ROUTING.PATH_TRAINING_DOCUMENT_ADMIN;
      } else if (url[3] === PATH_ROUTING.PATH_GE_CONFIDENTIAL_DOCUMENTS_ADMIN_ADD || url[3] === 'edit-ge-confidential-documents') {
        this.menuAdmin = PATH_ROUTING.PATH_GE_CONFIDENTIAL_DOCUMENTS_ADMIN;
      } else if (url[3] === PATH_ROUTING.PATH_ADD_STAY_INFORMED_ADMIN || url[3] === 'edit-stay-informed-admin') {
        this.menuAdmin = PATH_ROUTING.PATH_STAY_INFORMED_ADMIN;
      } else if (url[3] === PATH_ROUTING.PATH_CONTRACT_ACCESS || url[3] === 'edit-contract-access') {
        this.menuAdmin = PATH_ROUTING.PATH_CONTRACT_ACCESS;      
      } else if (url[3] === PATH_ROUTING.PATH_DOCSTORE_ACCESS || url[3] === 'edit-docstore-access') {
          this.menuAdmin = PATH_ROUTING.PATH_DOCSTORE_ACCESS;
      } else {
        this.menuAdmin = url[3];
      }
    });
   }

  ngOnInit() {
  }

  public redirectTo(item) {
    if (item.url) {
      this.menuAdmin = item.url;
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, item.url]);
    } else {
      this.menuAdmin = item.id;
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'application-link', item.id]);
    }
  }

  public checkShowMenuAdmin() {
    const roles = atob(localStorage.getItem(btoa('role')));
    this.menu = this.menu.map((item: any) => {
      item.hidden = true;
      if (item.permissions.some(el => roles.split(',').some(r => r === el))) {
        item.hidden = false;
      }
      return item;
    });
    this.menu = this.menu.filter(item => !item.hidden);
  }
}
